import { Schedule } from "@mui/icons-material";
import { VspPortalAction } from "./VspPortalAction";
import { VspPortalActions } from "./VspPortalActions";
import { VspPortalState } from "./VspPortalState";


export const vspPortalReducer = ( state: VspPortalState, action: VspPortalAction ) => {

    switch ( action.type ) {

        case VspPortalActions.SetArrivalLogsPageNumber:
            return { ...state, arrivalLogsPageNumber : action.payload }
        
        case VspPortalActions.SetArrivalLogsPageSize:
            return { ...state, arrivalLogsPageSize : action.payload }

        case VspPortalActions.SetArrivalLogsSorting:
            return { ...state, ArrivalLogsSorting : action.payload }

        case VspPortalActions.SetCardSwapSearchResultPageNumber:
            return { ...state, cardSwapSearchResultPageNumber : action.payload }
        
        case VspPortalActions.SetCardSwapSearchResultPageSize:
            return { ...state, cardSwapSearchResultPageSize : action.payload }

        case VspPortalActions.SetCardSwapSearchResultSorting:
            return { ...state, cardSwapSearchResultSorting : action.payload }
        
        case VspPortalActions.SetCardSwapStatuses:
            return { ...state, cardSwapStatuses : action.payload }
        
        case VspPortalActions.SetFunctionKey:
            return { ...state, functionKey : action.payload };
        
        case VspPortalActions.SetIsDarkTheme:
            return { ...state, isDarkTheme : action.payload };
        
        case VspPortalActions.SetNotificationText:
            return { ...state, notificationText : action.payload };

        case VspPortalActions.SetNotificationType:
            return { ...state, notificationType : action.payload };

        case VspPortalActions.SetSchedule:
            return { ...state, schedule : action.payload }

        case VspPortalActions.SetUserGroups:
            return { ...state, userGroups : action.payload };

        case VspPortalActions.SetUserName:
            return { ...state, username : action.payload };

        case VspPortalActions.SetVillage:
            return { ...state, village : action.payload };

        case VspPortalActions.SetVillages:
        
            if( state.villages[action.payload.asset] === undefined ){

                const villages = { ...state.villages };
                villages[ action.payload.asset ] = action.payload.villageDtos;
                return { ...state, villages };

            } 

            return state;

        default:
            return state;
        
    }

}